import {
	OUTLET_PRICES_HISTORY_LABEL_KEYS,
	SHOP_PRICES_HISTORY_LABEL_KEYS,
} from '@fukku/price/keys'
import { Channel } from 'types/masterData'
import type { Price } from '../../../store/pricesStore/pricesStore'

export const PRICES_TOOLTIP_TITLE = 'productCard.priceHistory.title'

const THREE_PRICES = 3
const TWO_PRICES = 2

export function getTooltipPricesKeys(channel: Channel, pricesHistory: Price[]) {
	if (channel === Channel.Shop) {
		return SHOP_PRICES_HISTORY_LABEL_KEYS
	}
	const [mangoPrice, outletPrice, _omnibusPrice, currentPrice] =
		OUTLET_PRICES_HISTORY_LABEL_KEYS
	if (pricesHistory.length === THREE_PRICES) {
		return [mangoPrice, outletPrice, currentPrice]
	}
	if (pricesHistory.length === TWO_PRICES) {
		return [mangoPrice, currentPrice]
	}
	return OUTLET_PRICES_HISTORY_LABEL_KEYS
}
